<template>
  <div>
    <div class="block-special clearfix">
      <div class="special-item fl" @click="goDetail(item)" v-for="(item, index) in list" :class="index % 5 != 0?'special-item-mr':''" :key="index">
        <img v-if="item.masterImg" :src="item.masterImg" alt="" class="special-item-img">
        <img
              v-else
              class="special-item-img"
              src="@/assets/noclass.png"
          />
        <div class="special-text-box"> 
          <div class="special-text-name clearfix">
            <img :src="imgPath.home_recommend" alt="">
            {{item.name1}}
            <!-- <span class="des-word"></span> -->
          </div>
          <div class="count-box clearfix">
            <img class="count-icon fl" :src="imgPath.home_count" />            
            <span class="num fl" >{{item.productSales}}</span>
            <span class="price fr" v-if="item.mallPcPrice  && item.mallPcPrice != 0.00" >￥{{item.mallPcPrice}}</span>
            <span class="price fr" v-else>免费</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeBookCat} from "@/servers/api"
import imgPath from "@/common/img-path";
  export default {
    data () {
      return {
        imgPath:imgPath,
        list: []
      }
    },
    methods:{
        goDetail (item) {
          window.open('#/course/detail?id=' + item.id) 
          // const { href } = this.$router.resolve({
          //   path: '/course/detail',
          //   query: {
          //       id: 1
          //   }
          // });
          // window.open(href, '_blank');                
        },
       
        async getProductRecommendList() {
          const res = await getHomeBookCat({
            status: 1
          });
          if (res.code == 0) {
            this.list = res.data;
            // 前端暂时将数量限制
            if (this.list.length > 10) {
              this.list = this.list.slice(0, 10)
            }
          }
        }
    },
    created() {
      this.getProductRecommendList()
    }
  }
</script>

<style lang="less" scoped>
.block-special {
  .special-item-mr {
    margin-left: 15px;
  }
  
  .special-item {
    &:hover {
      box-shadow: 0px 16px 16px -12px #cdd0d2;
      transform: translateY(-7px);
    }
    width:226px;
    height:262px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(238,238,238,1);
    margin-bottom: 10px;
    cursor: pointer;
    .special-item-img {
      width:226px;
      height:134px;
    }
    .special-text-box {
      padding: 20px;
      .special-text-name {
        font-weight:500;
        color:rgba(51,51,51,1);
        // line-height:24px;
        font-size: 14px;
        height: 48px;
        margin-bottom: 27px;

        
        img {
          width:16px;
          height:16px;
          margin-right: 10px;
          display: inline-block;
          // float: left;
        }
        .des-word {
          // float: left;
          // width: 155px;
          height: 45px;
          font-size: 14px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          white-space:normal;
          word-break:break-all;
       
        }
      }
      .count-box {
        .count-icon {
          margin-right: 6px;
          width: 13px;
          height: 15px;
        }
        .num {
          opacity: 1;
          line-height: 14px;
          letter-spacing: 1px;
          white-space: nowrap;
          color: #999999;
          font-family: Helvetica;
          font-size: 12px;
          
        }
        .price {
          opacity: 1;
          line-height: 19px;
          white-space: nowrap;
          color: #ec493b;
          font-family: Helvetica;
          font-size: 16px;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>